import './UserMenu.scss';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";

import A from 'components/A';
import Avatar from 'components/Avatar';
import Icon from 'components/Icon';

export default class UserMenu extends React.Component {
    static propTypes = {
        pathname: PropTypes.string.isRequired,
        user: PropTypes.object.isRequired
    };

    constructor() {
        super();

        this.links = [{
            text: 'Recommend a Freelancer',
            href: '/recommend'
        }/*, {
            text: 'Help',
            href: '/help'
        }*/, {
            text: (<span>Logout <Icon type="logout" /></span>),
            href: '/logout'
        }]
    }

    render() {
        return (
            <div className="c-user-menu">
                <Avatar imageUrl={this.props.user.company != null ? this.props.user.company.profilePicUrl : this.props.user.profilePicUrl} size="small" />

                <div className="c-user-menu__name">
                    Hi, {this.props.user.company != null ? this.props.user.company.name : this.props.user.firstName} <Icon type="chevron-down" />
                </div>

                <ul className="c-user-menu__menu-items">
                    {this.links.map((link, index) => {
                        return (
                            <li className="c-user-menu__menu-item" key={index}>
                                <A className={classNames('c-user-menu__link', {'a-user-menu__link--active': link.activeTest != null ? link.activeTest() : this.props.pathname === link.href})}
                                   to={link.href}>
                                    {link.text}
                                </A>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/UserMenu/index.js